import React, { useEffect, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';

import { LoaderComponent } from 'shared/LoaderComponent';
import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';

function TagFilter() {
  const {
    fullTags,
    onTagChange,
    fileManagerFilters,
    isTagsLoading,
    setSelectedRows,
    isContentSearchActive,
    isCaseFileManager,
    isLeadFileManager,
  } = useFileManagerContext();
  const [caseTagOptions, setCaseTagOptions] = useState([]);

  const shouldDisable = isContentSearchActive && (isCaseFileManager || isLeadFileManager);

  useEffect(() => {
    if (fullTags.length > 0) {
      let data = fullTags.map((val) => ({
        label: `${val}`,
        value: `${val}`,
      }));
      setCaseTagOptions(data);
    } else {
      setCaseTagOptions([]);
    }
  }, [fullTags]);

  return (
    <div className="filter-wraper">
      <Dropdown
        value={fileManagerFilters.tag}
        name="tag"
        options={caseTagOptions}
        placeholder="By Tag"
        className="file-manager-select col-sm-12"
        onChange={(e) => {
          onTagChange(e);
          setSelectedRows([]);
        }}
        filter
        panelFooterTemplate={isTagsLoading ? LoaderComponent : null}
        disabled={shouldDisable}
      />
    </div>
  );
}

export default TagFilter;
